export default {"src":"/_next/static/media/claimed_frame.19b5dc79.svg","height":36,"width":98,"blurWidth":0,"blurHeight":0};